import React from 'react';
import logo from '../../images/a-logo.svg';
import SubscribeAction from '../SubscribeAction';
import Typography from '../Typography';

interface NewsletterCardProps {
  title: string;
  categories: string[];
  description?: string;
  listId: string;
}

const NewsletterCard: React.FC<NewsletterCardProps> = ({
  title,
  categories,
  description,
  listId,
}) => {
  return (
    <article className="ckp-m-card">
      <div className="ckp-m-card__image" aria-hidden>
        <img src={logo} />
      </div>

      <div className="ckp-m-card__content">
        <Typography variant="h3" as="h6" classNames="u-margin-bottom-xs">
          {title}
        </Typography>
        <Typography variant="small">
          <strong>{categories.join(', ')}</strong>
        </Typography>
        {description && <Typography classNames="u-margin-top-xs">{description}</Typography>}

        <SubscribeAction listId={listId} />
      </div>
    </article>
  );
};

export default NewsletterCard;
